// import React from "react";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";
import { resetApiCancelSource } from "../../actions/apiCancelSource";
import { clearProgressItems } from "../../actions/progressList";

class UserInterruption extends Component {
  // componentWillReceiveProps(nextProps) {
  //   if (
  //     !nextProps.cancelSources &&
  //     Object.keys(nextProps.cancelSource).length > 0
  //   ) {
  //     this.props.resetApiCancelToken();
  //   }
  // }

  handleCancelRequest = () => {
    if (this.props.cancelSource) {
      this.props.cancelSource.source.cancel("User cancelled");
    }
    this.props.resetApiCancelToken();
    this.props.clearProgressItems();
  };

  render() {
    return this.props.cancelSources ? (
      <Button id="searchCancel" onClick={this.handleCancelRequest}>
        {this.props.cancelSource.type === 2 ? "Cancel" : "Run in Background"}
      </Button>
    ) : null;
  }
}

// const UserInterruption = props => {
//   if (props.displayCancel === true)
//     return (
//       <Button id="searchCancel" onClick={props.handleCancelRequest}>
//         Cancel
//       </Button>
//     );
//   return null;
// };

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    cancelSource: state.apiCancelSource,
    cancelSources:
      state.progressList &&
      state.progressList.cancelSources &&
      state.progressList.cancelSources.length > 0
        ? state.progressList.cancelSources
        : undefined,
  };
}

export default connect(mapStateToProps, {
  resetApiCancelToken: resetApiCancelSource,
  clearProgressItems,
})(UserInterruption);



// WEBPACK FOOTER //
// ./src/components/searches/UserInterruption.js